var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:{ pointer: _vm.clickable },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"flex"},[_c('img',{attrs:{"src":_vm.iconPath}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }